<template>
    <sticky full-width class="layout-header">
        <div class="layout-header--inner">
            <btn theme="link" size="sm" icon="menu" title="Menu" class="layout-header--toggle" v-if="showCanvas" @click="$emit('toggle')"/>

            <router-link to="/" class="layout-header--brand">
                <img src="/img/start-logo-rot.svg" alt="START-Stiftung"/>
                <h1>Wir&nbsp;sind&nbsp;START</h1>
            </router-link>
            
            <layout-search v-if="!hideSearch" placeholder="wirsindstart.de durchsuchen..." class="flex-grow-1 mx-2"/>
            <div v-else class="flex-grow-1" />


            <flex justify="end" class="layout-header--account">
                <template v-if="user">
                    <btn theme="none" :label="user.fullname" class="layout-header--fullname mr-2 text-truncate" v-bind="user.link"/>
                    <btn theme="link" size="sm" icon="logout-variant" title="Abmelden" @click="$store.dispatch('auth/logout')"/>
                </template>
            </flex>
        </div>
    </sticky>
</template>

<style lang="scss">
    .layout-header {
        top: 0;
        left: 0;
        background: $white;
        box-shadow: $layout-shadow;
        z-index: 2;
    }
    .layout-header--inner {
        display: flex;
        align-items: center;
        max-width: $layout-max-width;
        width: 100%;
        margin: 0 auto;
        padding: 0 $spacer-3;
        height: $layout-header-height;
    }
    .layout-header--toggle {
        display: none;
        color: $dark-70;
        font-size: 28px;
            margin-right: $spacer-2;
    }
    .layout-header--brand {
        display: flex;
        align-items: center;
        width: $layout-sidebar-width;

        img {
            height: $layout-header-height - 20px;
        }
        h1 {
            font-size: 18px;
            color: $red;
            font-weight: bold;
            margin-left: $spacer-2;
            margin-bottom: 0;
        }
    }
    .layout-header--account {
        width: $layout-sidebar-width;

        a {
            color: $dark-70;
        }
        .mdi {
            font-size: 24px;
        }
    }

    @include media-breakpoint-down("lg") {
        .layout-header--toggle {
            display: block;
        }
    }
    @include media-breakpoint-down("md") {
        .layout-header--account {
            width: auto;
        }
        .layout-header--fullname {
            display: none;
        }
        .layout-header--inner {
            justify-content: space-between;
        }
        .layout-header--brand {
            width: auto;
        }
        .layout-header .layout-search {
            display: none;
        }
    }
    @include media-breakpoint-down("sm") {
        .layout-header--inner {
            padding: 0 $spacer-2;
        }
    }
</style>

<script>
    export default {
        props: {
            hideSearch: {type: Boolean, default: false},
            showCanvas: {type: Boolean, default: false},
        },

        computed: {
            user() {
                return this.$store.getters['auth/getUser'];
            },
        },
    };
</script>